import GlobalAppLayoutContainer from './GlobalAppLayoutContainer';
export default GlobalAppLayoutContainer;
